import PropTypes from 'prop-types'
import BagItem from './bag-item'
import { BagProductsList } from './styles'

const BagItems = ({ lineItems = [], onQuantityChange }) => {
  return (
    <BagProductsList>
      {lineItems.map(item => (
        <BagItem
          key={item.recalculatedLineItem.id}
          item={item}
          onQuantityChange={onQuantityChange}
        />
      ))}
    </BagProductsList>
  )
}

BagItems.propTypes = {
  lineItems: PropTypes.array.isRequired,
  onQuantityChange: PropTypes.func.isRequired
}

BagItems.defaultProps = {
  onQuantityChange: () => {}
}

export default BagItems
